import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="remote-modal"
export default class extends Controller {
  static values = { confirmMessage: String }
  connect() {
    this.handleTabShown = this.handleTabShown.bind(this)
    this.handleFrameMissing = this.handleFrameMissing.bind(this)

    this.element.addEventListener('shown.bs.tab', this.handleTabShown)
    this.element.addEventListener('turbo:frame-missing', this.handleFrameMissing)

    this.element.addEventListener('hide.bs.modal', (e) => {
      const message = this.hasConfirmMessageValue ? this.confirmMessageValue : "You have unsaved data. Are you sure you want to close this modal?"
      if (this.hasUnsavedData() && !confirm(message)) {
        e.preventDefault()
      }
    });

    this.element.addEventListener('hidden.bs.modal', () => {
      const parentFrame = this.element.closest('turbo-frame')
      if (parentFrame) {
        parentFrame.removeAttribute('src')
      }
    });

    const ModalClass = window.bootstrap?.Modal || (typeof bootstrap !== 'undefined' && bootstrap.Modal)
    if (ModalClass) {
      this.modal = typeof ModalClass.getOrCreateInstance === 'function' ? ModalClass.getOrCreateInstance(this.element) : new ModalClass(this.element)
    }
    this.open()
  }

  disconnect() {
    this.element.removeEventListener('shown.bs.tab', this.handleTabShown)
    this.element.removeEventListener('turbo:frame-missing', this.handleFrameMissing)

    if (this.modal) {
      try {
        this.modal.hide()
        this.modal.dispose()
      } catch (e) {}
    }

    if (!document.querySelector('.modal.show')) {
      document.querySelectorAll('.modal-backdrop').forEach((el) => el.remove())
      document.body.classList.remove('modal-open')
      document.body.style.removeProperty('padding-right')
      document.body.style.removeProperty('overflow')
    }
  }

  handleTabShown(event) {
    const targetSelector = event.target?.getAttribute('data-bs-target')
    if (!targetSelector) return

    const targetPane = this.element.querySelector(targetSelector)
    if (!targetPane) return

    const lazyFrame = targetPane.querySelector('turbo-frame[loading="lazy"]')
    if (lazyFrame && typeof lazyFrame.load === 'function' && !lazyFrame.complete && !lazyFrame.busy) {
      lazyFrame.load()
    }
  }

  handleFrameMissing(event) {
    const frame = event.target
    if (frame && frame.id && frame.id.includes('candidate_job_')) {
      event.preventDefault()
      frame.innerHTML = `
        <div class="alert alert-light border text-center py-4 my-3">
          <i class="fa-solid fa-circle-exclamation text-warning fa-2x mb-2 d-block"></i>
          <p class="mb-2 text-muted">Não foi possível carregar esta seção no momento.</p>
          <button class="btn btn-sm btn-outline-primary" type="button" onclick="this.closest('turbo-frame').reload()">
            <i class="fa-solid fa-arrow-rotate-right me-1"></i> Tentar novamente
          </button>
        </div>
      `
    }
  }

  open() {
    if (!this.isOpen()) {
      this.modal.show()
    }
  }

  close(e) {
    if (this.isOpen()) {
      this.modal.hide()
    }
  }

  closeAfterSubmit(e) {
    if (e.detail.success && !this.keepModalOpen(e)) {
      this.removeUnsavedData()

      this.close(e)
    }
  }

  isOpen() {
    return this.element.classList.contains("show")
  }

  keepModalOpen(e) {
    return e.detail.fetchResponse.response.headers.get('keep_modal_open') == 'true'
  }

  hasUnsavedData() {
    return this.element.querySelectorAll('form[data-changed="true"]').length > 0
  }

  removeUnsavedData() {
    this.element.querySelectorAll('form[data-changed="true"]').forEach((form) => {
      form.removeAttribute('data-changed')
    })
  }
}
